export const POST_ANSWER_INIT = 'POST_ANSWER_INIT'
export const POST_ANSWER_SUCCESS = 'POST_ANSWER_SUCCESS'
export const POST_ANSWER_FAILED = 'POST_ANSWER_FAILED'
export const ADD_FUNDING_ACCOUNT_INIT = 'ADD_FUNDING_ACCOUNT_INIT'
export const ADD_FUNDING_ACCOUNT_SUCCESS = 'ADD_FUNDING_ACCOUNT_SUCCESS'
export const ADD_FUNDING_ACCOUNT_FAILED = 'ADD_FUNDING_ACCOUNT_FAILED'
export const MANAGE_BANK_ACCOUNT_INIT = 'MANAGE_BANK_ACCOUNT_INIT'
export const MANAGE_BANK_ACCOUNT_SUCCESS = 'MANAGE_BANK_ACCOUNT_SUCCESS'
export const MANAGE_BANK_ACCOUNT_FAILED = 'MANAGE_BANK_ACCOUNT_FAILED'
export const DELETE_BANK_ACCOUNT_INIT = 'DELETE_BANK_ACCOUNT_INIT'
export const DELETE_BANK_ACCOUNT_SUCCESS = 'DELETE_BANK_ACCOUNT_SUCCESS'
export const DELETE_BANK_ACCOUNT_FAILED = 'DELETE_BANK_ACCOUNT_FAILED'
export const POST_INVESTING_STEPS_INIT = 'POST_INVESTING_STEPS_INIT'
export const POST_INVESTING_STEPS_SUCCESS = 'POST_INVESTING_STEPS_SUCCESS'
export const POST_INVESTING_STEPS_FAILED = 'POST_INVESTING_STEPS_FAILED'
export const GET_INVEST_MONEY_INIT = 'GET_INVEST_MONEY_INIT'
export const GET_INVEST_MONEY_SUCCESS = 'GET_INVEST_MONEY_SUCCESS'
export const GET_INVEST_MONEY_FAILED = 'GET_INVEST_MONEY_FAILED'
export const GET_COMPLETED_TOUR_INIT = 'GET_COMPLETED_TOUR_INIT'
export const GET_COMPLETED_TOUR_SUCCESS = 'GET_COMPLETED_TOUR_SUCCESS'
export const GET_COMPLETED_TOUR_FAILED = 'GET_COMPLETED_TOUR_FAILED'
export const DONE_SUCCESS = 'DONE_SUCCESS'
export const GET_TOUR_TOKEN_INIT = 'GET_TOUR_TOKEN_INIT'
export const GET_TOUR_TOKEN_SUCCESS = 'GET_TOUR_TOKEN_SUCCESS'
export const GET_TOUR_TOKEN_FAILED = 'GET_TOUR_TOKEN_FAILED'
export const GET_INVESTMENT_HISTORY_INIT = 'GET_INVESTMENT_HISTORY_INIT'
export const GET_INVESTMENT_HISTORY_SUCCESS = 'GET_INVESTMENT_HISTORY_SUCCESS'
export const GET_INVESTMENT_HISTORY_FAILED = 'GET_INVESTMENT_HISTORY_FAILED'
export const TAX_INFORMATION_DATA = 'TAX_INFORMATION_DATA'
export const SET_CURRENT = 'SET_CURRENT'
export const IS_DEBOUNCE_LOADER = 'IS_DEBOUNCE_LOADER'
export const UPDATE_INVESTING_TYPE_INIT = 'UPDATE_INVESTING_TYPE_INIT'
export const UPDATE_INVESTING_TYPE_SUCCESS = 'UPDATE_INVESTING_TYPE_SUCCESS'
export const UPDATE_INVESTING_TYPE_FAILED = 'UPDATE_INVESTING_TYPE_FAILED'
export const UPDATE_BUSINESS_TYPE_INIT = 'UPDATE_BUSINESS_TYPE_INIT'
export const UPDATE_BUSINESS_TYPE_SUCCESS = 'UPDATE_BUSINESS_TYPE_SUCCESS'
export const UPDATE_BUSINESS_TYPE_FAILED = 'UPDATE_BUSINESS_TYPE_FAILED'
export const GET_TAX_INFO_INIT = 'GET_TAX_INFO_INIT'
export const GET_TAX_INFO_SUCCESS = 'GET_TAX_INFO_SUCCESS'
export const GET_TAX_INFO_FAILED = 'GET_TAX_INFO_FAILED'
export const SUBMIT_TAX_INFO_INIT = 'SUBMIT_TAX_INFO_INIT'
export const SUBMIT_TAX_INFO_SUCCESS = 'SUBMIT_TAX_INFO_SUCCESS'
export const SUBMIT_TAX_INFO_FAILED = 'SUBMIT_TAX_INFO_FAILED'

export const TAX_FORM_FILE_UPLOAD_INIT = 'TAX_FORM_FILE_UPLOAD_INIT'
export const TAX_FORM_FILE_UPLOAD_SUCCESS = 'TAX_FORM_FILE_UPLOAD_SUCCESS'
export const TAX_FORM_FILE_UPLOAD_FAILED = 'TAX_FORM_FILE_UPLOAD_FAILED'

export const GET_ACCREDITATION_INFO_INIT = 'GET_ACCREDITATION_INFO_INIT'
export const GET_ACCREDITATION_INFO_SUCCESS = 'GET_ACCREDITATION_INFO_SUCCESS'
export const GET_ACCREDITATION_INFO_FAILED = 'GET_ACCREDITATION_INFO_FAILED'

export const SUBMIT_ACCREDITATION_INFO_INIT = 'SUBMIT_ACCREDITATION_INFO_INIT'
export const SUBMIT_ACCREDITATION_INFO_SUCCESS = 'SUBMIT_ACCREDITATION_INFO_SUCCESS'
export const SUBMIT_ACCREDITATION_INFO_FAILED = 'SUBMIT_ACCREDITATION_INFO_FAILED'
export const STRIPE_VERIFY_IDENTITY_INIT = 'STRIPE_VERIFY_IDENTITY_INIT'
export const STRIPE_VERIFY_IDENTITY_SUCCESS = 'STRIPE_VERIFY_IDENTITY_SUCCESS'
export const STRIPE_VERIFY_IDENTITY_FAILED = 'STRIPE_VERIFY_IDENTITY_FAILED'

export const STRIPE_FINANCIAL_CONNECTIONS_INIT = 'STRIPE_FINANCIAL_CONNECTIONS_INIT'
export const STRIPE_FINANCIAL_CONNECTIONS_SUCCESS = 'STRIPE_FINANCIAL_CONNECTIONS_SUCCESS'
export const STRIPE_FINANCIAL_CONNECTIONS_FAILED = 'STRIPE_FINANCIAL_CONNECTIONS_FAILED'

export const GET_BANKING_INFO_INIT = 'GET_BANKING_INFO_INIT'
export const GET_BANKING_INFO_SUCCESS = 'GET_BANKING_INFO_SUCCESS'
export const GET_BANKING_INFO_FAILED = 'GET_BANKING_INFO_FAILED'

export const CREATE_INVESTOR_INVESTMENT_PROFILE_INIT = 'CREATE_INVESTOR_INVESTMENT_PROFILE_INIT'
export const CREATE_INVESTOR_INVESTMENT_PROFILE_SUCCESS = 'CREATE_INVESTOR_INVESTMENT_PROFILE_SUCCESS'
export const CREATE_INVESTOR_INVESTMENT_PROFILE_FAILED = 'CREATE_INVESTOR_INVESTMENT_PROFILE_FAILED'

export const UPDATE_INVESTOR_INVESTMENT_PROFILE_INIT = 'UPDATE_INVESTOR_INVESTMENT_PROFILE_INIT'
export const UPDATE_INVESTOR_INVESTMENT_PROFILE_SUCCESS = 'UPDATE_INVESTOR_INVESTMENT_PROFILE_SUCCESS'
export const UPDATE_INVESTOR_INVESTMENT_PROFILE_FAILED = 'UPDATE_INVESTOR_INVESTMENT_PROFILE_FAILED'

export const ADD_FUNDING_ACC_EURO_INIT = 'ADD_FUNDING_ACC_EURO_INIT'
export const ADD_FUNDING_ACC_EURO_SUCCESS = 'ADD_FUNDING_ACC_EURO_SUCCESS'
export const ADD_FUNDING_ACC_EURO_FAILED = 'ADD_FUNDING_ACC_EURO_FAILED'
